import React, { FC, useEffect } from 'react'

import { useFormProvider } from '../Providers/form'

interface TaskWizardContextProps {
  setTaskConfiguration: (configuration: object) => void
}

const TaskWizardContext = React.createContext<TaskWizardContextProps | null>(null)

interface TaskWizardProviderProps {
  children: React.ReactNode
}

export const TaskWizardProvider: FC<TaskWizardProviderProps> = ({ children }) => {
  const { associatedTaskItem: item, form } = useFormProvider()

  useEffect(() => {
    if (item && item?.taskTypeConfiguration && form) {
      setTaskConfiguration(JSON.parse(String(item?.taskTypeConfiguration)))
    }
  }, [item, form])

  const setTaskConfiguration = (configuration: object) => {
    const taskConfiguration = form.get('task_type_configuration')

    taskConfiguration.set({ ...taskConfiguration.value, ...configuration })
  }

  return (
    <TaskWizardContext.Provider
      value={{
        setTaskConfiguration,
      }}
    >
      {children}
    </TaskWizardContext.Provider>
  )
}
export const useTaskWizard = (): TaskWizardContextProps => {
  const TaskWizardModule = React.useContext(TaskWizardContext)

  if (!TaskWizardModule) throw new Error('useTaskWizard must be used within an TaskWizardProvider')

  return TaskWizardModule
}
